module.exports = __webpack_public_path__ + "img/prime-location.9751dcec.webp";